export default function isValidZipCode(value: string): boolean {
  return /^\d{5}$/.test(value);
}
